module.exports = __webpack_public_path__ + "img/phone-chat.19c7e02b.webp";